module.exports = __webpack_public_path__ + "static/media/forest-bg.c01a822c.jpg";